import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {DDay} from "../DDay";

export class DDayPickAndClickIdlePresentation implements FlowStatePresentation {

    constructor() {
    }

    public async start(flowStateController: FlowStateController) {
        if (DDay.model.isRestore) {
            DDay.freespinIntro.show(() => {
            });
        } else {
            DDay.freespinIntro.startClick();
        }
        flowStateController.finish();
    }
}
